import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PdfViewerComponent } from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss']
})
export class PdfPreviewComponent {
  @Input() visible = false;
  @Input() title = 'PDF Preview';
  @Input() pdfBytes: Uint8Array | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  @ViewChild('pdfViewer') pdfViewer!: PdfViewerComponent;

  public readonly resourceUrl = new URL('assets/ej2-pdfviewer-lib', document.baseURI).toString();

  onDialogOpen(): void {
    if (!this.pdfBytes) {
      return;
    }

    setTimeout(() => {
      this.pdfViewer?.load(this.pdfBytes, null);
    }, 0);
  }

  onDialogClose(): void {
    this.pdfViewer?.unload();
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit();
  }
}
